import { IApplicationState } from '../../types/redux';

export function getNewbuildingWebsite(state: IApplicationState) {
  const {
    newbuilding: { website },
  } = state;

  return website;
}
